module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'btn-group-vertical': _vm.vertical, 'btn-group': !_vm.vertical, 'full-width': _vm.fullWidth
    }
  }, _vm._l((_vm.buttons), function(button, index) {
    return _c('button', {
      staticClass: "btn btn-default",
      class: {
        active: _vm.activeIndex == index, 'full-width': _vm.fullWidth
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.input(button.value, index)
        }
      }
    }, [('icon' in button) ? _c('i', {
      staticClass: "fa",
      class: button.icon
    }) : _vm._e(), _vm._v("\n\t\t" + _vm._s(button.text) + "\n\t")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70f303a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonGroup.vue
// module id = 298
// module chunks = 0